import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL + "/admin/install-keys";

const getAllInstallKeys = () => {
    return axios.get(API_URL, { headers: authHeader() });
};

const updateInstallKey = (id, installKey) => {
    return axios.put(`${API_URL}/${id}`, { installKey }, { headers: authHeader() });
};

const installKeyService = {
    getAllInstallKeys,
    updateInstallKey,
};

export default installKeyService;
